module.exports = __webpack_public_path__ + "static/media/reload.f2973ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/admin/reload.svg
// module id = 1050
// module chunks = 0